import {
  DEFAULT_TRANSFER_JOB_STATE,
  TRANSFER_JOB_MAX_HISTORY,
  transferBatchesState,
} from './transferJobs';
import {
  DEFAULT_TRANSFER_JOB_TASK_STATE,
  INITIAL_TRANSFER_JOB_TASK_STATE,
  transferJobTasksState,
} from './transferJobTasks';

export const state = {
  transferBatches: transferBatchesState,
  transferJobTasks: transferJobTasksState,
};

export const defaults = {
  DEFAULT_TRANSFER_JOB_STATE,
  INITIAL_TRANSFER_JOB_TASK_STATE,
  DEFAULT_TRANSFER_JOB_TASK_STATE,
  TRANSFER_JOB_MAX_HISTORY,
};
